import { z } from 'zod';
/**
 * Public error codes (guide §13). The list grows per phase; codes are stable identifiers,
 * messages are localized at the edge (widget) or kept generic (management API).
 */
export const ERROR_CODES = [
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'IDEMPOTENCY_MISMATCH',
    'PAYLOAD_TOO_LARGE',
    'VALIDATION_FAILED',
    'RATE_LIMITED',
    'QUOTA_EXCEEDED',
    'SERVICE_UNAVAILABLE',
    'INTERNAL',
];
export const errorEnvelopeSchema = z.object({
    error: z.object({
        code: z.enum(ERROR_CODES),
        message: z.string(),
        requestId: z.uuid(),
    }),
});
export const HTTP_STATUS_BY_ERROR_CODE = {
    UNAUTHENTICATED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    IDEMPOTENCY_MISMATCH: 409,
    PAYLOAD_TOO_LARGE: 413,
    VALIDATION_FAILED: 422,
    RATE_LIMITED: 429,
    QUOTA_EXCEEDED: 429,
    SERVICE_UNAVAILABLE: 503,
    INTERNAL: 500,
};
//# sourceMappingURL=errors.js.map